import { render } from "./AppBreadcrumb.vue?vue&type=template&id=2bc56b6a&scoped=true"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"

import "./AppBreadcrumb.vue?vue&type=style&index=0&id=2bc56b6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc56b6a"]])

export default __exports__